module.exports = __webpack_public_path__ + "_assets/img/delete.8eef6e1b.svg";